import PropTypes, {string} from "prop-types";
import {Step, StepLabel, Stepper} from "@mui/material";

import "./RaikoStepper.scss"

export const RaikoStepper = (
    {
        steps = [],
        activeStep = 0,
        orientation = "horizontal",
        alternativeLabel = false,
        className
    }) => {
    return (
        <Stepper
            activeStep={activeStep}
            orientation={orientation}
            alternativeLabel={alternativeLabel}
            className={`raikoStepperContainer ${className}`}>
            {steps.map((label, index) => {
                return <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            })}
        </Stepper>
    )
}

RaikoStepper.propTypes = {
    steps: PropTypes.arrayOf(string).isRequired,
    activeStep: PropTypes.number.isRequired,
    orientation: PropTypes.oneOf(["horizontal", "vertical"]),
    alternativeLabel: PropTypes.bool,
    className: PropTypes.string
}